import { ReactComponent as MobileSpinnerImg } from '../../images/mobile-spinner.svg';

const MobileAppSpinner = ({ size = 70 }) => <MobileSpinnerImg height={size} />;

export default MobileAppSpinner;
